import { render, staticRenderFns } from "./List.vue?vue&type=template&id=67f9f4bf&scoped=true&"
import script from "./List.vue?vue&type=script&lang=js&"
export * from "./List.vue?vue&type=script&lang=js&"
import style0 from "./List.vue?vue&type=style&index=0&id=67f9f4bf&lang=stylus&scoped=true&"
import style1 from "./List.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f9f4bf",
  null
  
)

export default component.exports